import * as React from 'react';
import { useSelector } from 'react-redux';

import { constructionStatusDescriptors } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { IApplicationState } from '../../types/redux';
import { FilterTooltip } from '../../components/FilterTooltip';
import { ConstructionStatus } from './ConstructionStatus';

const getConstructionStatusButtonText = (activeDescriptors: typeof constructionStatusDescriptors): string => {
  if (activeDescriptors.length === 0) {
    return 'Год сдачи';
  }

  if (activeDescriptors.length === 1) {
    const descriptor = activeDescriptors[0];
    // Для "Дом сдан" используем оригинальный label
    if (descriptor.label === 'Дом сдан') {
      return descriptor.label;
    }

    // Для годов добавляем "Сдача в"
    return `Сдача в ${descriptor.label}`;
  }

  // Для множественного выбора показываем диапазон или список
  const years = activeDescriptors.map(d => d.label);

  return `Сдача: ${years.join(', ')}`;
};

export const FinishDate: React.FC = React.memo(() => {
  const jsonQuery = useSelector((state: IApplicationState) => state.jsonQuery);

  const activeDescriptors = React.useMemo(
    () => constructionStatusDescriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery)),
    [jsonQuery],
  );

  const buttonText = React.useMemo(() => getConstructionStatusButtonText(activeDescriptors), [activeDescriptors]);

  return (
    <FilterTooltip buttonText={buttonText} maxWidth={162} dataTestId="FinishDateQuickFilter">
      <ConstructionStatus autoApply />
    </FilterTooltip>
  );
});

FinishDate.displayName = 'FinishDate';
